<template>
  <v-container grid-list-xl fluid>
    <v-layout row wrap>
      <v-progress-linear
        indeterminate
        :active="isRequestingNow.length > 0"
        color="blue"
        class="mb-0"
      ></v-progress-linear>
      <v-overlay :value="pageLoading">
        <v-progress-circular indeterminate size="64"></v-progress-circular>
      </v-overlay>
      <v-flex v-if="!pageLoading" style="position: relative">
        <v-container class="grey lighten-5">
          <v-row no-gutters class="pagination-table-header">
            <v-col
              v-if="regionsItems"
              cols="12"
              md="6"
              class="px-1 md-0"
            >
              <v-select
                v-model="editableObject.region"
                :hint="$t('hints.region')"
                :items="regionsItems"
                persistent-hint
                single-line
                :loading="false"
                :error-messages="(errors && errors['region']) ? errors['region'] : null"
                @change="removeError('region')"
              ></v-select>

            </v-col>
            <v-col
              cols="12"
              md="6"
              class="px-1 md-0"
            >
              <v-menu
                v-model="showDatePicker"
                :close-on-content-click="false"
                transition="scale-transition"
                offset-y
                max-width="290px"
                min-width="290px"
              >
                <template v-slot:activator="{ on }">
                  <v-text-field
                    :value="accountingDateFormatted"
                    :label="lang($store, 'sap/listings.global.filter.hints.date')"
                    prepend-icon="mdi-calendar"
                    readonly
                    clearable
                    :error-messages="(errors && errors['accounting_date']) ? errors['accounting_date'] : null"
                    @input="removeError('accounting_date')"
                    v-on="on"
                  ></v-text-field>
                </template>
                <v-date-picker
                  v-model="editableObject.accounting_date"
                  no-title
                  :first-day-of-week="1"
                  :locale="getCurrentLocale()"
                  @input="showDatePicker = false; removeError('accounting_date');"
                ></v-date-picker>
              </v-menu>
            </v-col>

            <v-col
              cols="12"
              class="pt-4"
            >
              <v-row>
                <v-col
                  cols="12"
                  md="6"
                >
                  <v-card
                    class="pa-1 px-2"
                    style="position: relative"
                  >
                    <v-row>
                      <v-col
                        cols="12"
                        class="pt-4 text-center"
                      >
                        {{ $t('menu.orders_base') }}
                      </v-col>
                      <v-col
                        v-for="(item, index) in editableObject.items"
                        v-if="item.order_category==='base' && item.is_subscription!==1"
                        :key="index + '-' + item.order_category + '-' + item.order_type"
                        cols="12"
                      >
                        <v-text-field
                          type="number"
                          v-model="item.amount"
                          prepend-icon="mdi-cash-100"
                          :label="lang($store,`sap/listings.global.filter.order_base_types.${item.order_type}`)"
                          autocomplete="off"
                          :error-messages="handleItemError(index)"
                          @input="removeItemError(index)"
                          :loading="false"
                        ></v-text-field>
                      </v-col>
                    </v-row>
                  </v-card>
                </v-col>
                <v-col
                  cols="12"
                  md="6"
                >
                  <v-card
                    class="pa-1 px-2"
                    style="position: relative"
                  >
                    <v-row>
                      <v-col
                        cols="12"
                        class="pt-4 text-center"
                      >
                        {{ $t('menu.orders_complex')}}
                      </v-col>
                      <v-col
                        v-for="(item, index) in editableObject.items"
                        v-if="item.order_category==='complex' && item.is_subscription!==1"
                        :key="index + '-' + item.order_category + '-' + item.order_type"
                        cols="12"
                      >
                        <v-text-field
                          type="number"
                          v-model="item.amount"
                          prepend-icon="mdi-cash-100"
                          :label="lang($store,`sap/listings.global.filter.order_complex_types.${item.order_type}`)"
                          autocomplete="off"
                          :error-messages="handleItemError(index)"
                          @input="removeItemError(index)"
                          :loading="false"
                        ></v-text-field>
                      </v-col>
                    </v-row>
                  </v-card>
                </v-col>

<!--                <v-col-->
<!--                  cols="12"-->
<!--                >-->
<!--                  <v-card-->
<!--                    class="pa-1 px-2"-->
<!--                    style="position: relative"-->
<!--                  >-->
<!--                    <v-row>-->
<!--                      <v-col-->
<!--                        cols="12"-->
<!--                        class="pt-4 text-center"-->
<!--                      >-->
<!--                        {{ $t('menu.orders_base') }} - {{ $t('subscriptions.title') }}-->
<!--                      </v-col>-->
<!--                      <v-col-->
<!--                        v-for="(item, index) in editableObject.items"-->
<!--                        v-if="item.order_category==='base' && item.is_subscription===1"-->
<!--                        :key="index + '-' + item.order_category + '-' + item.order_type"-->
<!--                        cols="12"-->
<!--                      >-->
<!--                        <v-text-field-->
<!--                          type="number"-->
<!--                          v-model="item.amount"-->
<!--                          prepend-icon="mdi-cash-100"-->
<!--                          :label="lang($store,`sap/listings.global.filter.order_base_types.${item.order_type}`)"-->
<!--                          autocomplete="off"-->
<!--                          :error-messages="handleItemError(index)"-->
<!--                          @input="removeItemError(index)"-->
<!--                          :loading="false"-->
<!--                        ></v-text-field>-->
<!--                        <v-text-field-->
<!--                          type="number"-->
<!--                          v-model="item.amount_with_additions"-->
<!--                          prepend-icon="mdi-cash-100"-->
<!--                          :label="lang($store,`sap/listings.global.filter.order_base_types.${item.order_type}`)-->
<!--                            + ' (' + lang($store, 'sap/listings.global.filter.hints.additional_services') + ')'"-->
<!--                          autocomplete="off"-->
<!--                          :error-messages="handleItemError(index, 'amount_with_additions')"-->
<!--                          @input="removeItemError(index, 'amount_with_additions')"-->
<!--                          :loading="false"-->
<!--                        ></v-text-field>-->
<!--                      </v-col>-->
<!--                    </v-row>-->
<!--                  </v-card>-->
<!--                </v-col>-->
              </v-row>

              <v-row>
                <v-col>
                  <v-btn
                    color="primary darken-1"
                    dark text
                    @click="onAction">
                    {{ this.lang(this.$store, 'sap/listings.global.edit.create') }}
                  </v-btn>
                </v-col>
              </v-row>
            </v-col>

          </v-row>
        </v-container>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import i18n from '@/i18n'
import moment from 'moment';
import debounce from 'lodash/debounce';
/* constants */
import { DATE_ISO } from '@/constants/dates';
import { REGIONS } from '~constants/region';
/* utils */
import {cloneObj, deepMerge, prepareValidationMessages} from '@/utils';
/* proxies */
import RevenueProxy from '@/proxies/Revenue/RevenueProxy';
/* mixins */
import updatePageContentMixin from '@/mixins/updatePageContentMixin';
import validationMixin from '@/mixins/validationMixin';
import orderBaseTypeFilter from '@/mixins/filters/orderBaseTypeFilter';
import orderComplexTypeFilter from '@/mixins/filters/orderComplexTypeFilter';
/* components */
import CopyButton from '@/components/minialerts/CopyButton.vue';
import DatetimePicker from '@/components/DatetimePicker.vue';
import _ from "lodash";

export default {
  name: 'RevenueBulkCreate',
  mixins: [
    updatePageContentMixin,
    validationMixin,
    orderBaseTypeFilter,
    orderComplexTypeFilter,
  ],
  components: {
    CopyButton,
    DatetimePicker,
  },
  data() {
    return {
      pageLoading: false,
      shouldSeeLoaderOnUpdating: true,
      isRequestingNow: [],
      useNullableOrderBaseType: false,
      useNullableOrderComplexType: false,
      showDatePicker: false,
      /* Data */
      initialEditableObject: {
        region: null,
        accounting_date: '',
        items: [],
      },
      editableObject: {},
      errors: {},
    };
  },
  mounted() {
    this.initEditableObject();
  },
  computed: {
    dateIso() {
      return this.editableObject.datetime ? moment(this.editableObject.datetime).toISOString() : null;
    },
    regionsItems() {
      const items = [];
      Object.keys(REGIONS)
        .forEach(key => {
          if (key === 'defaultRegionText') {
            return true;
          }
          items.push({
            text: i18n.t(`global.filter.regions.${REGIONS[key]}`),
            value: REGIONS[key],
          });
        });
      return items;
    },
    accountingDateFormatted() {
      return this.formatDate(this.editableObject.accounting_date);
    },
  },
  watch: {
  },
  methods: {
    getCurrentLocale() {
      return window.localStorage.language;
    },
    initEditableObject() {
      const firstRegion = this.regionsItems.find(() => true);
      if (firstRegion !== undefined) {
        this.initialEditableObject.region = firstRegion.value;

      }

      this.orderBaseTypeItems.forEach(item => {
        this.initialEditableObject.items.push({
          'order_category': 'base',
          'order_type': item.value,
          'is_subscription': 0,
          'amount': 0,
          'amount_with_additions': 0,
        });
      });

      this.orderComplexTypeItems.forEach(item => {
        this.initialEditableObject.items.push({
          'order_category': 'complex',
          'order_type': item.value,
          'is_subscription': 0,
          'amount': 0,
          'amount_with_additions': 0,
        });
      });

      /*this.subscriptionOrderBaseTypeItems.forEach(item => {
        this.initialEditableObject.items.push({
          'order_category': 'base',
          'order_type': item.value,
          'is_subscription': 1,
          'amount': 0,
          'amount_with_additions': 0,
        });
      });*/

      const tmp = deepMerge(cloneObj(this.initialEditableObject), {});
      this.editableObject = tmp;
    },
    formatDate(date) {
      if (!date) return null;

      const [year, month, day] = date.split('-');
      return `${day}/${month}/${year}`;
    },
    handleItemError(index, field = '') {
      if (field.length) {
        let errorField = 'items.' + index + '.' + field;
        if (this.errors && errorField in this.errors) return this.errors[errorField];
        return null;
      }

      let errorField = 'items.' + index + '.' + 'amount';
      if (this.errors && errorField in this.errors) return this.errors[errorField];
      errorField = 'items.' + index + '.' + 'order_category';
      if (this.errors && errorField in this.errors) return this.errors[errorField];
      errorField = 'items.' + index + '.' + 'order_type';
      if (this.errors && errorField in this.errors) return this.errors[errorField];
      errorField = 'items.' + index + '.' + 'is_subscription';
      if (this.errors && errorField in this.errors) return this.errors[errorField];
      return null;
    },
    removeItemError(index, field = '') {
      if (field.length) {
        let errorField = 'items.' + index + '.' + field;
        this.removeError(errorField);
        return;
      }

      let errorField = 'items.' + index + '.' + 'amount';
      this.removeError(errorField);
      errorField = 'items.' + index + '.' + 'order_category';
      this.removeError(errorField);
      errorField = 'items.' + index + '.' + 'order_type';
      this.removeError(errorField);
      errorField = 'items.' + index + '.' + 'is_subscription';
      this.removeError(errorField);
    },
    onAction() {
      this.errors = {};

      if (_.isObject(this.editableObject)) {
        this.pageLoading = true;

        let client = new RevenueProxy();
        const data = {};

        data.region = this.editableObject.region;
        data.accounting_date = moment(this.editableObject.accounting_date).format(DATE_ISO);
        data.items = [];
        this.editableObject.items.forEach(item => {
          data.items.push({
            'order_category': item.order_category,
            'order_type': item.order_type,
            'is_subscription': item.is_subscription,
            'amount': item.amount,
            'amount_with_additions': item.amount_with_additions,
          });
        });

        client.create(data)
          .then((response) => {
            this.$store.dispatch('page/displaySnackbar', {
              text: i18n.t('messages.data_saved'),
              color: 'teal lighten-3',
              timeout: 20000,
            });
            return this.$router.push({
              name: 'revenue',
            });
          })
          .catch((response) => {
            this.pageLoading = false;
            let errors = [];
            if (response && response.data && response.data.data) {
              this.errors = prepareValidationMessages(response.data.data);
              errors = Object.values(this.errors);
            }
            if (errors.length) {
              this.$store.dispatch('page/displaySnackbar', {
                text: i18n.t('messages.error') + '. ' + errors[0],
                color: 'red darken-3',
                timeout: 20000,
              });
            } else {
              this.$store.dispatch('page/displaySnackbar', {
                text: i18n.t('messages.undefined_error'),
                color: 'red darken-3',
                timeout: 20000,
              });
              console.error(response);
            }
          });
      }
    },
  },
};
</script>
